import { ExternalLinkIcon } from '@slal/ui/icons';
import { LinkProps } from 'react-router';
import { StyledLink } from './styles';

export const ExternalLink = ({ children, ...otherProps }: LinkProps) => {
    return (
        <StyledLink target="_blank" {...otherProps}>
            {children}
            <ExternalLinkIcon />
        </StyledLink>
    );
};
